import { Pipe, PipeTransform } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'preview',
  standalone: false,
})
export class PreviewPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(value: boolean): any {
    let type: string = '';

    switch (value) {
      case false:
        type = this.translate.instant('本番');
        break;
      case true:
        type = this.translate.instant('プレ');
        break;
    }
    return type;
  }

}
